import { Fragment } from 'react';
import { ButtonBase, Grid, Tooltip, withStyles } from '@material-ui/core';
import FormattedAmount from 'components/FormattedAmount';
import infoIcon from '../../img/info.svg';
import greyInfoIcon from '../../img/info_gray.svg';
import successInfoIcon from '../../img/info_success.svg';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { modalsToggle } from '../../actions';
import { reset } from 'redux-form';
import NotesModal from '../Modals/NotesModal';

const StyledGridContainer = styled(Grid)`
  max-width: 400px;
  padding: 6px;
`;

const StyledGridItemLabel = styled(Grid)`
  color: #616161;
  padding: 4px 8px;
`;

const StyledGridItem = styled(Grid)`
  color: #757575;
  padding: 4px 8px;
`;

const StyledInfoButton = styled(ButtonBase)`
  span {
    font-size: 18px;
  }
`;

const StyledImg = styled.img`
  height: 24px;
`;

const styles = () => ({
  tooltip: {
    backgroundColor: '#ffffff',
    color: '#616161',
    fontSize: 14,
    opacity: 1
  },
  popper: {
    backgroundColor: '#ffffff',
    opacity: 1,
    wordBreak: 'break-word',
    boxShadow: '0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)'
  }
});

const createOtherOfferInitialValues = (type, offers) => {
  if (typeof offers === 'number') {
    return {
      [`${type}_opening_bid`]: offers,
      [`${type}_bid`]: null,
      [`${type}_sold`]: null
    };
  }

  return {
    [`${type}_opening_bid`]: offers?.opening_bid,
    [`${type}_bid`]: offers?.bid,
    [`${type}_sold`]: offers?.sold,
    [`${type}_fake_user_id`]: offers?.fake_user_id,
    [`${type}_checkbox`]: offers?.checked
  };
};

const NotesTooltip = ({ vehicleData, classes }) => {
  const ParsedInfoIcon = (() => {
    if (vehicleData.admin_finalize_notes) return successInfoIcon;
    if (vehicleData.admin_notes) return infoIcon;
    return greyInfoIcon;
  })();

  const dispatch = useDispatch();
  const toggleNotesModal = () => dispatch(modalsToggle(`notesModal_${vehicleData.id}`));

  const { open: isOpened, modalId } = useSelector(state => state.modals || {});

  const resetForm = id => dispatch(reset(id));

  return (
    <>
      <Tooltip
        disableFocusListener
        disableTouchListener
        classes={{ tooltip: classes.tooltip, popper: classes.popper }}
        title={
          vehicleData.admin_notes || vehicleData.reserve_price || vehicleData.starting_bid ? (
            <StyledGridContainer container>
              {vehicleData.admin_notes ? (
                <StyledGridItemLabel item xs={12}>
                  {vehicleData.admin_notes}
                </StyledGridItemLabel>
              ) : null}
              {vehicleData.reserve_price ? (
                <Fragment>
                  <StyledGridItem item xs={12}>
                    <FormattedAmount amount={vehicleData.reserve_price} />
                  </StyledGridItem>
                </Fragment>
              ) : null}
              {vehicleData.starting_bid ? (
                <Fragment>
                  <StyledGridItem item xs={12}>
                    <FormattedAmount amount={vehicleData.starting_bid} />
                  </StyledGridItem>
                </Fragment>
              ) : null}
            </StyledGridContainer>
          ) : (
            'Click to add notes'
          )
        }
      >
        <StyledInfoButton onClick={toggleNotesModal}>
          <ParsedInfoIcon />
        </StyledInfoButton>
      </Tooltip>

      {isOpened && modalId === `notesModal_${vehicleData.id}` ? (
        <NotesModal
          modalId={`notesModal_${vehicleData.id}`}
          vehicle={vehicleData}
          initialValues={{
            adminNotes: vehicleData.admin_notes || '',
            inspectorNotes: vehicleData.inspector_notes?.message || '',
            inspectorPrivateNotes: vehicleData.private_inspector_notes?.message || '',
            salespersonNotes: vehicleData.salesperson_notes || '',
            adminFinalizeNotes: vehicleData.admin_finalize_notes || '',
            reserve_price: vehicleData.reserve_price || '',
            starting_bid: vehicleData.starting_bid ?? 100,
            bluebook_value: vehicleData.bluebook_value,
            bluebook_mileage: vehicleData.bluebook_mileage,
            alternative_offer: vehicleData.active_alternative_offer?.amount ?? '',
            ...createOtherOfferInitialValues('acv', vehicleData.other_offers?.acv),
            ...createOtherOfferInitialValues('other', vehicleData.other_offers?.other),
            ...createOtherOfferInitialValues('open_lane', vehicleData.other_offers?.open_lane)
          }}
          resetForm={id => resetForm(id)}
        />
      ) : null}
    </>
  );
};

export default withStyles(styles)(NotesTooltip);
